export const SET_PARAMS = '@params/set';

export const setParams = fields => dispath =>
  dispath({
    type: SET_PARAMS,
    payload: { fields }
  });
